module.exports = __webpack_public_path__ + "static/media/studio-2.76e2987e.jpg";